import React, { useEffect, useRef } from "react";
import amal from "../images/amal.png";
import qmz from "../images/qmz.png";
import estet from "../images/estet.png";
import sabah from "../images/sabah.png";
import asc from "../images/asc.png";
import iek from "../images/iek.png";
import jysk from "../images/jysk.png";
import shinkar from "../images/shinkar.png";
import nurmmc from "../images/nurmmc.png";

const Partners = () => {
  const carouselRef = useRef(null);
  const partners = [
    { img: qmz, name: "QMZ" },
    { img: estet, name: "Estet" },
    { img: sabah, name: "Sabah" },
    { img: asc, name: "ASC" },
    { img: iek, name: "IEK" },
    { img: jysk, name: "JYSK" },
    { img: amal, name: "Amal" },
    { img: shinkar, name: "Shinkar" },
    { img: nurmmc, name: "NurMMC" },
  ];

  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    // Clone the first few items and append them to create the infinite effect
    const scrollWidth = carousel.scrollWidth / 2;
    let scrollPosition = 0;

    const scroll = () => {
      scrollPosition += 1;

      // Reset position when we've scrolled through the first set
      if (scrollPosition >= scrollWidth) {
        scrollPosition = 0;
        carousel.scrollLeft = 0;
      } else {
        carousel.scrollLeft = scrollPosition;
      }
    };

    const interval = setInterval(scroll, 30);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-[30px] bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-8">
          Partnyorlarımız
        </h2>

        <div className="relative overflow-hidden">
          {/* Gradient overlays for better UX */}
          <div className="absolute left-0 top-0 h-full w-12 bg-gradient-to-r from-gray-50 to-transparent z-10"></div>
          <div className="absolute right-0 top-0 h-full w-12 bg-gradient-to-l from-gray-50 to-transparent z-10"></div>

          {/* Carousel container */}
          <div
            ref={carouselRef}
            className="flex overflow-x-hidden py-6 scroll-smooth"
          >
            {/* Double the items for infinite scroll effect */}
            {[...partners, ...partners].map((partner, index) => (
              <div
                key={index}
                className="flex-none px-6 transition-all duration-300 grayscale hover:grayscale-0 hover:scale-110"
                style={{ minWidth: "180px" }}
              >
                <div className="h-20 flex items-center justify-center bg-white rounded-lg shadow-sm p-4 hover:shadow-md transition-shadow">
                  <img
                    src={partner.img}
                    alt={`${partner.name} logo`}
                    className="max-h-12 max-w-full object-contain"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
